import { useOktaAuth } from '@okta/okta-react'
import { Link, useLocation } from 'react-router-dom'
import { AppHeader, Avatar, Button, Text } from '@nike/eds'
import { NikeApp } from '@nike/nike-design-system-icons'
import { useMemo } from 'react'
import Config from '../../../config/Config'

function CommandBarLink({ link, text }) {
  const { pathname } = useLocation()
  const active = link === pathname
  return (
    <Link
      to={link}
      style={{
        marginRight: 'var(--eds-space-16)',
      }}
    >
      <Text as="p" font="subtitle-2" color={active ? 'white' : 'secondary'}>
        {text}
      </Text>
    </Link>
  )
}

function Header() {
  const { authState } = useOktaAuth()
  const initials = useMemo(() => {
    const name = authState?.idToken?.claims?.name
    return name ? getInitials(name) : '-'
  }, [authState])

  const env = Config.ENV
  const appName = env === 'PR' ? 'Shipment Tracking' : `Shipment Tracking (${env})`

  return (
    <AppHeader
      isDark
      appName={
        <Text font="title-6" as="h1">
          {appName}
        </Text>
      }
      logoSlot={
        <Link reloadDocument to="/shipments" aria-label="logo-link">
          <NikeApp
            title="Nike logo"
            color="white"
            width="56px"
            height="64px"
            style={{ marginTop: '6px' }}
          />
        </Link>
      }
      avatarSlot={<Avatar initials={initials} size={36} />}
      toolbarSlot={
        <Button
          variant="ghost"
          disableRipple
          className="eds-spacing--mr-4"
          onClick={() => window.open('slack://channel?team=T0G3T5X2B&id=C04TFCUSBAS', '_self')}
        >
          #ask-maverick
        </Button>
      }
      commandBarSlot={
        <nav aria-label="Main" className="eds-flex eds-flex--direction-row">
          <CommandBarLink link="/shipments" text="Shipments" />
          <CommandBarLink link="/orders" text="Orders" />
        </nav>
      }
    />
  )
}

function getInitials(name: string) {
  const matchedFirstLetters = name.match(/(\b[A-Z])/g)
  if (!matchedFirstLetters || matchedFirstLetters.length < 2) {
    // Fallback: take first letter
    return name[0]?.toUpperCase()
  }
  return `${matchedFirstLetters.shift()}${matchedFirstLetters.pop()}`
}

export default Header
